<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title :title="$t(`tasks.${task.identifier}.label`)" :moduleIdentifier="task.module.identifier">
        <span slot="header-right" class="badge" :class="task.status">{{ $t(`batch.statuses.${task.status}.label`) }}</span>
        <button slot="header-right" @click="showModal()" class="btn hint hint--left error btn-cancel" data-label="Clique aqui para cancelar tarefa" v-if="task.status === 'pending'">
          <i class="icon-blocked"></i>
        </button>
      </page-title>

      <modal-cancel v-model="cancelItemFlag" v-on:option="cancelTask(task)"/>

      <div class="progress-bar" v-if="task.status === 'processing'">
        <progress class="progress" :value="percent / 100" slot="floor"></progress>
        <div class="progress-bar-label" :style="`width: ${percent}%`">{{ dataLabel }}</div>
      </div>

      <div class="l-row vertical-flex">
        <div v-if="task.options" class="l-col-6@md">
          <panel title="Opções">
            <span v-for="option in Object.keys(task.options)" :key="option" class="ds-block">
              <span v-if="isObjectOption(option)" v-for="optionDetail in Object.keys(task.options[option])" :key="optionDetail" class="ds-block">
                <strong>{{ optionDetail === 'auxiliary' ? $t(`${task.options.price.type}.label`) : $t(`${option}.${optionDetail}.label`) }}:</strong>
                {{
                  $te(`${task.options[option][optionDetail]}.label`) ?
                    $t(`${task.options[option][optionDetail]}.label`) :
                    isObject(task.options[option][optionDetail]) ?
                      getValues([option, optionDetail], task.options[option][optionDetail]) :
                      applyMask([option, optionDetail], task.options[option][optionDetail])
                }}
              </span>
              <span v-if="!isObjectOption(option)">
                <strong>{{ $t(`${option}.label`) }}:</strong>
                <span v-if="option !== 'file'">
                  {{
                  $te(`${task.options[option]}.label`) ?
                    $t(`${task.options[option]}.label`) :
                    getLabel(option)
                  }}
                </span>
                <a v-else :href="task.options[option]">
                  <span class="hint hint--right" data-label="Baixe aqui">
                    Fazer download
                  </span>
                  <i class="icon-file-download"/>
                </a>
              </span>
            </span>
          </panel>
        </div>

        <div :class="informationAndOptionsPanelColumns">
          <panel title="Informações">
            <span class="ds-block"><strong>Criado por:</strong> {{ task.user }}</span>
            <span class="ds-block"><strong>Total de itens:</strong> {{ task.totalItems }}</span>
            <span class="ds-block"><strong>Data de criação:</strong> {{ formatDate(this.task.created) }}</span>
            <span class="ds-block" v-if="task.processing"><strong>Data de processamento:</strong> {{ formatDate(this.task.processing) }}</span>
            <span class="ds-block" v-if="task.done"><strong>Data de finalização:</strong> {{ formatDate(this.task.done) }}</span>
            <span class="ds-block" v-if="task.result && task.status === 'done'"><strong>Resultado</strong>
              <a
                :href="taskResultIsUrl ? task.result : null"
                @click="downloadTaskResult"
                :download="taskResultIsUrl ? null : taskResultDownloadFileName"
              >
                <span class="hint hint--right" data-label="Baixe aqui">
                  Fazer download
                </span>
                <i class="icon-file-download"/>
              </a>
            </span>
          </panel>
        </div>
      </div>

      <div class="l-row vertical-flex" v-if="task.filters">
        <div :class="filtersPanelColumns">
          <panel title="Filtros">
            <span v-for="filter in Object.keys(task.filters)" class="ds-block">
              <div v-if="filter !== 'source'">
                <strong>{{ $t(`${filter}.label`) }}:</strong>
                {{
                  $te(`${task.filters[filter]}.label`) ?
                    $t(`${task.filters[filter]}.label`) :
                    isObject(task.filters[filter]) ?
                      formatObject((task.filters[filter])) :
                      $te(`mercadoLivre.types.${task.filters[filter]}.label`) ?
                        $t(`mercadoLivre.types.${task.filters[filter]}.label`) :
                        task.filters[filter] | nullableSanitize
                }}
              </div>
            </span>
          </panel>
        </div>

        <div v-if="task.filters.source" class="l-col-6@md">
          <panel title="Filtros da fonte">
            <span v-for="filter in Object.keys(task.filters.source)" class="ds-block">
              <div>
                <strong>{{ $t(`${filter}.label`) }}:</strong>
                {{
                  $te(`${task.filters.source[filter]}.label`) ?
                    $t(`${task.filters.source[filter]}.label`) :
                    isObject(task.filters.source[filter]) ?
                      getValues([filter], task.filters.source[filter]) :
                      task.filters.source[filter] | nullableSanitize
                }}
              </div>
            </span>
          </panel>
        </div>
      </div>

      <div class="l-row vertical-flex" v-if="task.comment">
        <div class="l-col-12@md">
          <panel title="Observações">
            {{ task.comment }}
          </panel>
        </div>
      </div>

      <panel title="Itens" class="blue-panel">
        <list filterTitle="Filtro de itens" :loading="loadingItems" :total="toolBatchTaskTotalTaskItems" @change="onChange" v-on:loadMore="loadMore">

          <template slot="filters">
            <form-group :label="$t('identifier.label')">
              <input class="form-input" v-model="options.identifier">
            </form-group>
            <form-group :label="$t('level.label')">
              <select v-model="options.level" class="form-select">
                <option :value=null>Todos</option>
                <option value="critical">{{ $t(`level.critical.label`) }}</option>
                <option value="warning">{{ $t(`level.warning.label`) }}</option>
                <option value="info">{{ $t(`level.info.label`) }}</option>
              </select>
            </form-group>
          </template>

          <div class="l-col-12@md" v-for="taskItem in toolBatchTaskTaskItems" :key="taskItem">
            <panel>
              <div class="l-row">
                <div class="l-col-12@md">
                  <span :class="`t-${taskItem.level}`">{{ taskItem.identifier }} - {{ taskItem.message }} - {{ formatDate(taskItem.created) }}</span>
                </div>
              </div>
            </panel>
          </div>

          <div class="l-col-12@md u-textCenter" v-if="!toolBatchTaskTaskItems.length">
            <panel>Nenhum item encontrado</panel>
          </div>
        </list>
      </panel>
    </div>
  </div>
</template>

<script>
  import { isObject, isNumber, merge } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import moment from 'moment'
  import List from '@/components/shared/list/Scroll'
  import ModalCancel from '@/components/Task/ModalCancel'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      task: null,
      loading: true,
      loadingItems: false,
      options: {
        identifier: null,
        level: null
      },
      cancelItemFlag: false
    }),
    props: {
      identifier: {
        type: String,
        required: true
      }
    },
    async created () {
      this.task = this.getTask(this.identifier)
      if (!this.task) {
        await this.addTask(this.identifier)
        this.task = this.getTask(this.identifier)
      }

      this.options.scope = `task_item_${this.identifier}`
      this.options.module_type = this.task.module.type
      this.options.module_identifier = this.task.module.identifier

      this.loading = false
    },
    methods: {
      ...mapActions('toolBatchTask', [
        'addTask',
        'fetchTaskItem',
        'fetchTaskItemMore',
        'cancelTask'
      ]),
      isObjectOption (option) {
        return isObject(this.task.options[option])
      },
      isObject (value) {
        return isObject(value)
      },
      formatObject (object) {
        let label = ''
        let value = ''
        for (let i in Object.keys(object)) {
          label = Object.keys(object)[i]
          value = object[label]
        }

        return `${this.$t(`${label}.label`)}: ${value}`
      },
      getValues (scope, values) {
        let strings = []
        for (let i in Object.keys(values)) {
          const key = Object.keys(values)[i]

          const label = this.$te(`${key}.label`)
            ? this.$t(`${key}.label`) : this.$te(`${scope.join('.')}.${key}.label`) ? this.$t(`${scope.join('.')}.${key}.label`) : key

          let value = this.$te(`${values[key]}.label`)
            ? this.$t(`${values[key]}.label`)
            : this.$te(`${scope.join('.')}.${values[key]}.label`)
              ? this.$t(`${scope.join('.')}.${values[key]}.label`)
              : values[key]

          if (scope.indexOf('price') !== -1 && isNumber(value)) {
            if (key === 'percent') {
              value = `${value}%`
            } else {
              value = `R$ ${value.toFixed(2)}`.replace('.', ',')
            }
          }

          strings.push(`${label}: ${value}`)
        }

        return strings.join(', ')
      },
      applyMask (scope, value) {
        if (scope.indexOf('price') !== -1 && isNumber(value)) {
          return `R$ ${value.toFixed(2)}`.replace('.', ',')
        }

        if (scope.indexOf('auxiliary') !== -1) {
          return `${value}%`
        }

        return value
      },
      async onChange (options) {
        this.loadingItems = true

        merge(this.options, options)

        await this.fetchTaskItem({
          options: this.options
        })

        this.loadingItems = false
      },
      async loadMore (options) {
        merge(this.options, options)

        await this.fetchTaskItemMore({
          options: this.options
        })

        options.fetchingMore = false
      },
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
      showModal () {
        this.cancelItemFlag = true
      },
      getLabel (option) {
        let label = this.task.options[option]

        if (this.$te(`tasks.${this.task.identifier}.options.${this.task.options[option]}.label`)) {
          label = this.$t(`tasks.${this.task.identifier}.options.${this.task.options[option]}.label`)
        }

        return label
      },
      downloadTaskResult (event) {
        if (!this.task || !this.task.result) {
          return
        }

        if (this.task.identifier !== 'exportProductCsv') {
          return
        }

        if (this.taskResultIsUrl) {
          return
        }

        event.preventDefault()

        let csvContent = this.task.result

        try {
          const parsedResult = JSON.parse(this.task.result)

          if (typeof parsedResult === 'string') {
            csvContent = parsedResult
          } else if (Array.isArray(parsedResult)) {
            csvContent = this.formatCsvArray(parsedResult)
          } else if (parsedResult && typeof parsedResult === 'object') {
            if (typeof parsedResult.csv === 'string') {
              csvContent = parsedResult.csv
            } else if (Array.isArray(parsedResult.data)) {
              csvContent = this.formatCsvArray(parsedResult.data)
            } else {
              csvContent = JSON.stringify(parsedResult)
            }
          }
        } catch (error) {
          csvContent = this.task.result
        }

        if (typeof csvContent !== 'string') {
          csvContent = String(csvContent)
        }

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = url
        link.download = this.taskResultDownloadFileName

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        URL.revokeObjectURL(url)
      },
      isUrl (value) {
        return typeof value === 'string' && /^(https?:\/\/|blob:|data:|\/)/.test(value)
      },
      formatCsvArray (rows) {
        if (!rows.length) {
          return ''
        }

        if (rows.every(row => Array.isArray(row))) {
          return rows.map(row => row.map(this.quoteCsvValue).join(',')).join('\n')
        }

        if (rows.every(row => row && typeof row === 'object' && !Array.isArray(row))) {
          const headers = Object.keys(rows[0])
          const body = rows.map(row => headers.map(key => this.quoteCsvValue(row[key])).join(','))
          return [headers.map(this.quoteCsvValue).join(','), ...body].join('\n')
        }

        return rows.map(this.quoteCsvValue).join('\n')
      },
      quoteCsvValue (value) {
        if (value === null || value === undefined) {
          return ''
        }

        const stringValue = String(value)

        if (/[[,"\n\r]]/.test(stringValue)) {
          return `"${stringValue.replace(/"/g, '""')}"`
        }

        return stringValue
      }
    },
    computed: {
      ...mapGetters('toolBatchTask', [
        'getTask'
      ]),
      ...mapFields({
        toolBatchTaskTotalTaskItems: 'toolBatchTask.totalTaskItems',
        toolBatchTaskTaskItems: 'toolBatchTask.taskItems'
      }),
      filtersPanelColumns () {
        if ((this.task.filters && this.task.filters.source)) {
          return 'l-col-6@md'
        }

        return 'l-col-12@md'
      },
      informationAndOptionsPanelColumns () {
        if (this.task.options) {
          return 'l-col-6@md'
        }

        return 'l-col-12@md'
      },
      fileName () {
        if (!this.task || !this.task.options || !this.task.options.file) {
          return `${this.task ? this.task.identifier : 'export'}.csv`
        }

        const arr = this.task.options.file.split('/')
        return arr[arr.length - 1]
      },
      taskResultIsUrl () {
        return this.task && typeof this.task.result === 'string' && /^(https?:\/\/|blob:|data:|\/)/.test(this.task.result)
      },
      taskResultHref () {
        return this.taskResultIsUrl ? this.task.result : null
      },
      taskResultDownloadFileName () {
        return this.fileName || `${this.task.identifier}.csv`
      },
      percent () {
        return ((this.task.totalItems - Object.keys(this.task.items).length) * 100) / this.task.totalItems
      },
      dataLabel () {
        const totalDone = this.task.totalItems - Object.keys(this.task.items).length
        return `${totalDone}/${this.task.totalItems}`
      }
    },
    components: {
      PageTitle,
      Panel,
      Loader,
      List,
      ModalCancel,
      FormGroup
    }
  }

</script>

<style lang="sass" scoped>
  .btn-cancel
    margin-left: 16px

  .progress
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0
    height: 32px
    position: relative

  .progress-bar
    position: relative

  .progress-bar-label
    line-height: 32px
    position: absolute
    display: block
    text-align: right
    color: #fff
    padding: 0 10px
    top: 0

  .progress[value]::-ms-fill
    border: none
    background-color: #800080 !important

  .progress[value]::-webkit-progress-bar
    background-color: #fff

  .progress[value]::-webkit-progress-value
    background-color: #800080 !important

  .progress[value]::-moz-progress-bar
    background-color: #800080 !important
</style>



// WEBPACK FOOTER //
// Detail.vue?17b8a7b0